const State = Object.freeze({
  ALIVE: 'alive',
  DEAD: 'dead',
  DETECTING: 'detecting',
  RELOAD: 'reload'
});
export { State };